"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var xml_utils_1 = require("xml-utils");
function findOperations(xml) {
    return (0, xml_utils_1.findTagsByPath)(xml, ["ows:OperationsMetadata", "ows:Operation"]).map(function (tag) { return tag.outer; });
}
exports.default = findOperations;
